import { useState, useEffect, useRef } from "react";
import { useParams, useNavigate } from "react-router-dom";
import CoorayFooter from "../../shared/components/footer/CoorayFooter";
import "../placedetails/css/PlaceDetailsPage.css"
import GoogleNavigateItem from "../../shared/components/googlenavigate/GoogleNavigateItem";
import { AnalyticsEvent } from "../../shared/analytics/AnalyticsEvent";
import { Helmet } from "react-helmet";
import { usePlaceDetailsContext } from "./PlaceDetailsContext";
import { useCurationPlacesContext } from "../curation/CurationPlacesContext";
import { LazyLoadImage } from "react-lazy-load-image-component";
import ExploreTagItem from "../../shared/components/exploreplaces/ExploreTagItem";
import { sendAction, sendPageView } from "../../shared/utils/AnalyticsUtils";
import ZipmapRepository from "../../repository/ZipmapRepository";
import { useCurationContext } from "../curation/CurationContext";
import CarouselModal from "../../shared/components/carousel/CarouselModal";
import { applyTheme } from "../../shared/utils/ThemeUtils";

export default function PlaceDetailsPage({viewingPlaceId, curationId, onBackPressed, analytics}) {
    console.log(`existing`)
    const {placesData, setPlacesData} = useCurationPlacesContext()
    const {placeDetails, setPlaceDetails} = usePlaceDetailsContext()
    const topRef = useRef()
    const mainDetailsContentRef = useRef()
    const [isMapUsingDarkMode, setIsMapUsingDarkMode] = useState(false)
    const [placeImages, setPlaceImages] = useState(placeDetails && placeDetails.images ? placeDetails.images : [])
    const [loadingText, setLoadingText] = useState(placeDetails? null: "Loading ...")
    const {curationData, setCurationData} = useCurationContext()
    const [selectedImage, setSelectedImage] = useState(null)
    const [isNavbarVisible, setIsNavbarVisible] = useState(false)
    const [isAddressCopied, setIsAddressCopied] = useState(false)
    const [bigCarouselPage, setBigCarouselPage] = useState(null)
    const [carouselImages, setCarouselImages] = useState([])
    const [toastMessage, setToastMessage] = useState(null)
    const [parentSlug, setParentSlug] = useState(curationData.curation.slug)
    const [parentTitle, setParentTitle] = useState(curationData.curation.title)
    const [parentId, setParentId] = useState(curationData.curation.id)
    const navigate = useNavigate()
    const { id }= useParams()
    const placeId = viewingPlaceId ?? Number(id.split('-').pop())
    useEffect(() => {
  
      async function afterFetchingDetails(details, collectionId) {
        console.log(`after fetching details ${JSON.stringify(details)} ${collectionId}`)
        setPlaceImages(details.images ?? [])
        setLoadingText(null)
        sendPageView(analytics, AnalyticsEvent.PLACE_DETAILS_VIEW, {
            placeId: placeId,
            collectionId: collectionId
          })
      }

      async function getPlaceDetails(id) {

        const zipmapRepository = new ZipmapRepository()
        const zipmapDetails = await zipmapRepository.getZipmapPlaceDetails(id)

        const placeDetails = {
          ...zipmapDetails.place,
          title: zipmapDetails.place.name,
        }
        setParentSlug(zipmapDetails.map.slug)
        setParentTitle(zipmapDetails.map.name)
        setParentId(zipmapDetails.map.id)
        setPlaceDetails(placeDetails)
        if (zipmapDetails.map.primaryColor) {
            applyTheme(zipmapDetails.map.primaryColor);
        }
        afterFetchingDetails(placeDetails, zipmapDetails.map.id)

      }

      const promises = []

      if (placeDetails == null || placeDetails.id != placeId) {
        promises.push(getPlaceDetails(placeId))
      } else {
        promises.push(afterFetchingDetails(placeDetails, parentId))
      }
      Promise.all(promises)

    }, [placeId])

    useEffect( ()=> {
        window.onpopstate = e => {
            console.log(`on pop ${window.location.href}`)
            if (!window.location.href.includes("#gallery")) {
              setBigCarouselPage(null)
            }
        }
        
        setIsMapUsingDarkMode(window.matchMedia('(prefers-color-scheme: dark)').matches)
        

    }, [])

    function onPlaceDetailsBackPressed() {
        if (curationData.curation.id > 0) {
            window.history.back()
        } else {
            navigate(`/${parentSlug}`, {replace: true})
        }
    }

    function onThumbnailClick(clickedId) {
        console.log(`thumbnail click ${clickedId}`)
        const carouselElement = document.getElementById("big-carousel")
        let carouselWidth = carouselElement.clientWidth
    
        let targetXPixel = (carouselWidth * clickedId) + 1
    
        carouselElement.scrollTo(targetXPixel, 0)

        sendAction(analytics, AnalyticsEvent.DETAILS_IMAGE_THUMBNAIL_CLICK, AnalyticsEvent.PLACE_DETAILS_VIEW, {
            place_id: placeDetails.id,
            thumbnail_index: clickedId
        })
    }

    function carouselLeftButtonClick() {
        const carouselElement = document.getElementById("big-carousel")
        let carouselWidth = carouselElement.clientWidth
        let scrollLeft = carouselElement.scrollLeft
        if (scrollLeft - carouselWidth >= 0) {
            carouselElement.scrollTo(scrollLeft - carouselWidth, 0)
        }
    }

    function carouselRightButtonClick() {
        const carouselElement = document.getElementById("big-carousel")
        let carouselWidth = carouselElement.clientWidth
        let scrollLeft = carouselElement.scrollLeft
        carouselElement.scrollTo(scrollLeft + carouselWidth, 0)
    }

    function onBigCarouselBackPressed() {
        window.history.back()
    }

    function onCarouselBigImagePressed(index) {
        console.log(`carousel big image pressed ${index}`)
        window.history.pushState("object or string", "Title", `/places/${placeId}#gallery`);
        setCarouselImages(placeImages)
        setBigCarouselPage(index)
        sendAction(analytics, AnalyticsEvent.DETAILS_BIG_IMAGE_CLICK, AnalyticsEvent.PLACE_DETAILS_VIEW, {
            place_id: placeDetails.id,
            big_image_index: index
        })
    }

    function resetAddressCopyState() {
        setIsAddressCopied(false)
    }

    const handleScroll = () => {
        const currentScrollPos = window.scrollY
        if (currentScrollPos > 64) {
            setIsNavbarVisible(true)
        } else {
            setIsNavbarVisible(false)
        }
    }

    const handleContentScroll = () => {
        const currentScrollPos =  mainDetailsContentRef.current.scrollTop
        if (currentScrollPos > 64) {
            setIsNavbarVisible(true)
        } else {
            setIsNavbarVisible(false)
        }
    }

    useEffect( () => {
        window.addEventListener('scroll', handleScroll);
        mainDetailsContentRef.current.addEventListener('scroll', handleContentScroll);
    })

    return (
        <div className="bg-base-100 h-full w-full overflow-y-scroll pb-4" ref={mainDetailsContentRef}>
            <Helmet><title>{ placeDetails ? placeDetails.title : "Loading ..." }{ parentTitle ? ` | ${parentTitle}` : "" }</title></Helmet>
            <div className="h-20"></div>
            <div className="font-bold px-4 md:px-8 font-titan w-full text-center text-4xl">{placeDetails ? placeDetails.title: ""}</div>

            {
                placeDetails && placeDetails.googlePlace && placeDetails.googlePlace.fullAddress &&
                <div className="flex pt-2 w-full text-sm justify-center text-base-content px-4 md:px-8">
                    <span className="self-center pr-4">{placeDetails.googlePlace.fullAddress}</span>
                    {
                        !isAddressCopied && <svg className="h-5 w-5 self-center" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" onClick={() => {
                                navigator.clipboard.writeText(placeDetails.googlePlace.fullAddress)
                                setIsAddressCopied(true)
                                setTimeout(resetAddressCopyState, 1000)
                                sendAction(analytics, AnalyticsEvent.DETAILS_COPY_ADDRESS_CLICK, AnalyticsEvent.PLACE_DETAILS_VIEW, {
                                    place_id: placeDetails.id
                                })
                            }
                        }>
                        <path className="fill-base-content" fillRule="evenodd" clipRule="evenodd" d="M21 8C21 6.34315 19.6569 5 18 5H10C8.34315 5 7 6.34315 7 8V20C7 21.6569 8.34315 23 10 23H18C19.6569 23 21 21.6569 21 20V8ZM19 8C19 7.44772 18.5523 7 18 7H10C9.44772 7 9 7.44772 9 8V20C9 20.5523 9.44772 21 10 21H18C18.5523 21 19 20.5523 19 20V8Z"/>
                        <path className="fill-base-content" d="M6 3H16C16.5523 3 17 2.55228 17 2C17 1.44772 16.5523 1 16 1H6C4.34315 1 3 2.34315 3 4V18C3 18.5523 3.44772 19 4 19C4.55228 19 5 18.5523 5 18V4C5 3.44772 5.44772 3 6 3Z" />
                        </svg>
                    }
                    {isAddressCopied && <svg className="h-5 w-5 self-center" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path className="stroke-base-content" d="M4 12.6111L8.92308 17.5L20 6.5" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    }
                </div>
            }
            <div className="grid grid-cols-1 md:grid-cols-2 mt-4 md:px-8 pb-20 min-h-[80vh] md:gap-4">
                {
                    placeImages && placeImages.length > 0 && <div className="row-span-2 md:row-span-1 md:order-last">
                    {
                        <div className="relative">
                            <div className="carousel md:rounded-lg h-96 carousel-center w-full overflow-y-hidden" id="big-carousel">
                                {
                                    placeImages.map((image, index) => {
                                    return <div className="carousel-item w-full h-full" id={`full-carousel-${index}`} key={`full-carousel-${index}`}>
                                            <div className="w-full h-96">
                                                { image.attributionHtml && <LazyLoadImage className="object-cover w-full h-80 rounded-none md:rounded-md" src={image.url} alt={image.attribution} onClick={() => { onCarouselBigImagePressed(index) }}/> }
                                                { !image.attributionHtml && <LazyLoadImage className="object-cover w-full h-96 rounded-none md:rounded-md" src={image.url} alt={image.attribution} onClick={() => { onCarouselBigImagePressed(index) }} /> }
                                                { image.attributionHtml && <div className="h-16 mt-auto w-full px-2 pt-2 text-center text-xs" 
                                                dangerouslySetInnerHTML={{__html: image.attributionHtml.map((link) => `Credit: ${link.replace("<a ", "<a target=\"_blank\"")}`).join("")}}></div> }
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                            <div className="absolute flex justify-between transform -translate-y-1/2 left-5 right-5 top-1/2 pointer-events-none">
                                <div className="btn btn-circle pointer-events-auto" onClick={() => carouselLeftButtonClick()}>❮</div> 
                                <div className="btn btn-circle pointer-events-auto" onClick={() => carouselRightButtonClick()}>❯</div>
                            </div>
                        </div>
                    }
                    {
                        placeImages.length > 0 && <div className="md:pr-4 pb-4">
                            {/* <input id="upload-image-input" type="file" accept="image/png, image/jpeg" className="file-input file-input-bordered w-full max-w-xs hidden" onChange={onFileInputChange}/> */}
                            <div id="place-images-container" className="carousel rounded-md h-24 w-full space-x-2">
                                {/* <div className="carousel-item w-2 rounded-md"></div> */}
                                <div className="carousel-item w-2 md:hidden"></div>
                            {
                                placeImages.map((image, index) => {
                                    return <div className="carousel-item" id={`thumbnail-${index}`} key={`thumbnail-${index}`} onClick={() => onThumbnailClick(index)}>
                                        <LazyLoadImage className="h-24 w-24 object-cover rounded-md" src={image.url} />
                                    </div>
                                })
                            }<div className="carousel-item w-2 md:hidden"></div></div>
                        </div>
                    }
                </div>
                }
                <div className="md:row-span-1">
                    { placeDetails && placeDetails.longDescription && <div className="grid grid-cols-[auto,1fr] md:rounded-md bg-base-200 mb-4 px-4 py-4 gap-y-2 gap-x-2 rounded-none">
                        <div className="grow text-sm self-center text-base-content md:text-base [&_p:empty]:min-h-[1.5em]" style={{ whiteSpace: 'pre-line' }} dangerouslySetInnerHTML={{ __html: placeDetails.longDescription }}>
                            {/* <div className="text-base md:text-lg font-bold pb-2 font-titan text-xl">What others say</div> */}
                            {/* {placeDetails.longDescription} */}
                        </div>
                    </div>}
                    {
                        placeDetails && placeDetails.filters && placeDetails.filters.length > 0 && <div className="md:rounded-md bg-base-200 mb-4 px-4 pt-4"> {placeDetails.filters.map((filter) => {
                            return <div className="pb-4">
                                <h3 className="text-sm md:text-base font-bold">{filter.label}</h3>
                                <div className="text-sm md:text-base self-start text-base-content flex flex-wrap gap-1 pt-2">

                                    { placeDetails.filterOptions.filter((tag) => filter.filterOptions.includes(tag.id))
                                    .map((tag) => <ExploreTagItem label={tag.label} isFixedToSmall={false} isHighlighted={tag.isSelected}/>) }
                                    {/* <FilterChipsContainer 
                                        key={filter.id}
                                        title={null}
                                        filterOptions={placeDetails.filterOptions.filter((option) => filter.filterOptions.includes(option.id))}
                                        onFilterOptionClick={() => {}}
                                        /> */}
                                </div>
                            </div>

                        })}</div>
                    }
                    {/* {
                        placeDetails && placeDetails.nearby && <div className="grid grid-cols-[auto,1fr] md:rounded-md bg-base-200 mb-4 px-4 py-4 gap-y-2 gap-x-2">
                            { placeDetails.nearby.metro && placeDetails.nearby.metro.length > 0 && <div className="font-bold pr-4">🚇 Metro</div> }
                            { placeDetails.nearby.metro && placeDetails.nearby.metro.length > 0 && <div>{ placeDetails.nearby.metro.join(", ") }</div> }
                            { placeDetails.nearby.landmarks && placeDetails.nearby.landmarks.length > 0 && <div className="font-bold pr-4">🏛️ Landmarks</div> }
                            { placeDetails.nearby.landmarks && placeDetails.nearby.landmarks.length > 0 && <div>{ placeDetails.nearby.landmarks.join(", ") }</div> }
                        </div>
                    } */}
                    {
                    placeDetails && placeDetails.staticMaps && <div className="pb-4">
                        <div className="h-52 md:h-52 rounded-md relative text-center">
                            <img className="object-cover w-full h-full rounded-md" src={isMapUsingDarkMode ? placeDetails.staticMaps.dark : placeDetails.staticMaps.light}/>
                            <div className="absolute bottom-4 w-full text-center">
                            <button className="btn btn-primary btn-sm md:btn-md normal-case text-sm md:text-base" onClick={() => {
                                window.open(placeDetails.googlePlace.mapsLink)
                                sendAction(analytics, AnalyticsEvent.DETAILS_VIEW_IN_MAPS_CLICK, AnalyticsEvent.PLACE_DETAILS_VIEW, {
                                    place_id: placeDetails.id
                                })
                            }}>View in Maps</button>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>
            <div className="w-full">
                    <CoorayFooter />
            </div>
            {loadingText &&
            <div className='w-full h-screen fixed top-0 flex flex-col items-center justify-center backdrop-blur-sm bg-base-100/30'>
                <div className="loading loading-infinity loading-lg"></div>
                <div className='font-normal text-base-content text-base mt-2'>{loadingText}</div>
            </div>
            }
            {
            <div className='max-w-1/2 fixed bottom-4 right-4 bg-transparent text-right flex flex-row gap-2 items-end'>
                {
                    placeDetails && placeDetails.googleMapUrl && <GoogleNavigateItem url={placeDetails.googleMapUrl} isSmall={false} onClick={() => {
                        sendAction(analytics, AnalyticsEvent.DETAILS_GOOGLE_NAVIGATE_CLICK, AnalyticsEvent.PLACE_DETAILS_VIEW, {
                            placeId: placeDetails.id,
                            collectionId: parentId
                        })
                    }}/>
                }
                <button className="btn text-base btn-secondary normal-case rounded-full btn-circle" onClick={() => { 
                    onPlaceDetailsBackPressed()
                }}>
                    <svg className="w-5 h-5 fill-primary-content" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M6.99486 7.00636C6.60433 7.39689 6.60433 8.03005 6.99486 8.42058L10.58 12.0057L6.99486 15.5909C6.60433 15.9814 6.60433 16.6146 6.99486 17.0051C7.38538 17.3956 8.01855 17.3956 8.40907 17.0051L11.9942 13.4199L15.5794 17.0051C15.9699 17.3956 16.6031 17.3956 16.9936 17.0051C17.3841 16.6146 17.3841 15.9814 16.9936 15.5909L13.4084 12.0057L16.9936 8.42059C17.3841 8.03007 17.3841 7.3969 16.9936 7.00638C16.603 6.61585 15.9699 6.61585 15.5794 7.00638L11.9942 10.5915L8.40907 7.00636C8.01855 6.61584 7.38538 6.61584 6.99486 7.00636Z"/></svg>
                </button>
            </div>
            }
            {/* {
                bigCarouselPage != null && <GalleryCarouselPage placeImages={carouselImages} onBigCarouselBackPressed={onBigCarouselBackPressed} currentPage={bigCarouselPage}/>
            } */}
            {
                bigCarouselPage != null && <CarouselModal isCarouselModalOpen={bigCarouselPage != null} onCarouselModalDismiss={onBigCarouselBackPressed} images={carouselImages} currentIndex={bigCarouselPage}/>
            }
            {<dialog id="generic-message-modal" className="modal">
                <div className="modal-box w-11/12 max-w-5xl">
                    <p className="py-2 text-base">{toastMessage}</p>
                    <div className="modal-action">
                        <button className="btn btn-ghost" onClick={() => { document.getElementById("generic-message-modal").close()}}>Ok</button>
                    </div>
                </div>
            </dialog>
            }
        </div>
    )
}
